import { render } from "./GymDance.vue?vue&type=template&id=0a04d467&scoped=true"
import script from "./GymDance.vue?vue&type=script&lang=js"
export * from "./GymDance.vue?vue&type=script&lang=js"

import "./GymDance.vue?vue&type=style&index=0&id=0a04d467&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a04d467"]])

export default __exports__